<template>
  <div class="print">
    <loader v-show="loading" />
    <div class="table-responsive" style="margin-bottom: 200px">
      <table border="0" style="width: 100%">
        <tbody>
          <tr>
            <td style="width: 60%">
              <img src="/logo/logo_512.png" height="80px;" />
              <br />
            </td>
            <td style="width: 40%">
              <strong style="font-size: 22px">INVOICE PENJUALAN</strong>
              <br />
              Nomor Invoice : {{ data.invoice }}
              <br />
              Tanggal : {{ data.created_at | dateFormat }}
            </td>
          </tr>
        </tbody>
      </table>
      <table width="100%" style="margin: 10px 0">
        <tbody v-if="data.customer">
          <tr>
            <td colspan="2">Kepada:</td>
          </tr>
          <tr>
            <td>Bapak/Ibu</td>
            <td>:</td>
            <td width="80%">{{ data.customer.name }}</td>
          </tr>
          <tr>
            <td>Alamat</td>
            <td>:</td>
            <td>{{ data.customer.address }}</td>
          </tr>
          <tr>
            <td>Nomor Telepon</td>
            <td>:</td>
            <td>{{ data.customer.phone }}</td>
          </tr>
        </tbody>
      </table>
      <div class="table-print">
        <table border="1" class="bordered" style="width: 100%">
          <thead>
            <tr>
              <th>No</th>
              <th>Kode Barang</th>
              <th>Jenis Barang</th>
              <th width="20">Jumlah</th>
              <th width="160">Harga</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(d, k) in data.sale_details" :key="k">
              <td class="center">{{ k + 1 }}</td>
              <td>{{ d.warranty.warranty }}</td>
              <td v-if="d.item">{{ d.item.name }}</td>
              <td class="center">{{ d.qty_real }}</td>
              <td class="right" width="100">
                {{ d.price | thousandSeparator }}
              </td>
            </tr>
            <tr class="footer">
              <td colspan="4" align="right">
                <b>TOTAL</b>
              </td>
              <td class="right">
                <b>Rp {{ data.total | thousandSeparator }}</b>
              </td>
            </tr>
            <tr class="footer">
              <td colspan="5">
                <b>Terbilang: {{ data.terbilang }} Rupiah</b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <table class="payment-detail">
      <tbody>
        <tr>
          <td width="50%">
            <br />
            <div v-if="data.method && data.method.bank_account">
              <strong>Pembayaran Melalui:</strong><br />
              {{ data.method.bank_account.name }} <br/>
              No. Rek {{ data.method.bank_account.number }}<br />
              a.n. {{ data.method.bank_account.owner_name }}<br />
            </div>
          </td>
          <td style="font-weight: 100">
            Note: {{ data.note }}<br /><br />
            <p style="width: 100%; text-align: right">Hormat Kami</p>
          </td>
        </tr>
      </tbody>
    </table>
      <div v-show="includeDeliveryLetter">
        <hr style="border: 1px dotted #000" />
        <h5 style="text-align: center; font-weight: bold; font-size: 22px">
          SURAT JALAN
        </h5>
        <div class="table-print">
          <table style="width: 100%" class="header">
            <tbody>
              <tr>
                <td style="width: 60%; padding: 0">
                  <table>
                    <tbody v-if="data.customer">
                      <tr>
                        <td width="160">Bapak/Ibu</td>
                        <td>:</td>
                        <td>{{ data.customer.name }}</td>
                      </tr>
                      <tr>
                        <td>Alamat</td>
                        <td>:</td>
                        <td>{{ data.customer.address }}</td>
                      </tr>
                      <tr>
                        <td>Nomor Telepon</td>
                        <td>:</td>
                        <td>{{ data.customer.phone }}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td style="width: 40%; vertical-align: top; padding: 0">
                  <table>
                    <tbody>
                      <tr>
                        <td>Nomor</td>
                        <td>:</td>
                        <td>{{ data.delivery_letter_number }}</td>
                      </tr>
                      <tr>
                        <td>Tanggal</td>
                        <td>:</td>
                        <td>{{ data.created_at | dateFormat }}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
          <table border="1" style="width: 100%" class="items">
            <thead>
              <tr>
                <th>No</th>
                <th>Jenis Barang</th>
                <th>Jumlah</th>
                <th width="170">Pengiriman</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(d, k) in data.sale_details"
                :key="k"
                v-show="d.include_delivery_letter"
              >
                <td class="center">{{ d.number }}</td>
                <td v-if="d.item">{{ d.item.name }}</td>
                <td class="center">{{ d.qty_real }}</td>
                <td>{{ data.courier }}</td>
              </tr>
            </tbody>
          </table>
          <table>
            <tbody>
              <tr>
                <td style="width: 10%">Pengirim</td>
                <td style="width: 80%"></td>
                <td style="width: 10%">Penerima</td>
              </tr>
              <tr>
                <td style="width: 10%; border-bottom: 1px dotted #000">
                  <br />
                </td>
                <td style="width: 80%"></td>
                <td style="width: 10%; border-bottom: 1px dotted #000">
                  <br />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Loader from '../../components/Loader.vue'
import { showErrorMessage } from '../../lib/helpers';
import { HTTPAUTH } from "../../lib/httplib";
export default {
  components: {
    Loader,
  },
  data () {
    return {
      data: [],
      includeDeliveryLetter: false,
      number: 0,
      loading: true
    };
  },
  created () {
    const params = this.$route.params;
    const query = this.$route.query;
    this.get(params.id);
    if (!query.preview) {
      // setTimeout(this.doPrint, 100);
    }
  },
  methods: {
    get (id) {
      this.loading = true
      HTTPAUTH.get("/api/v1/sale/" + id).then((res) => {
        this.data = res.data.data;
        const detail = this.data.sale_details;
        for (var i in detail) {
          if (detail[i].include_delivery_letter) {
            this.includeDeliveryLetter = true;
            this.includeDeliveryLetterCount++;
          }
        }
        this.loading = false
        // this.doPrint()
      }).catch(eres => {
        showErrorMessage(eres)
        this.loading = false
      });
    },
    doPrint () {
      setTimeout(function () {
        window.print();
        window.close();
      }, 100);
    },
  },
};
</script>